import Vue from 'vue'
import { API_URL } from '../../api'
import ComponentTypesFilter from '../../filters/ComponentTypesFilter';

const state = {
    componentTypeCreate: {
        createdComponentType: null,
        creatingComponentType: false,
        createComponentTypeStatus: null
    },
    componentTypeUpdate: {
        updatedComponentType: null,
        updatingComponentType: false,
        updateComponentTypeStatus: null
    },
    componentTypeDelete: {
        deletingComponentType: false,
        deleteComponentTypeStatus: null
    },
    componentTypeSearch: {
        componentTypesCount: null,
        componentTypes: [],
        searchingComponentTypes: false,
        searchComponentTypeStatus: null
    },
}
const mutations = {
    ['SET_COMPONENT_TYPE_CREATE'](state, change) {
        state.componentTypeCreate = { ...state.componentTypeCreate, ...change };
    },
    ['SET_COMPONENT_TYPE_UPDATE'](state, change) {
        state.componentTypeUpdate = { ...state.componentTypeUpdate, ...change };
    },
    ['SET_COMPONENT_TYPE_DELETE'](state, change) {
        state.componentTypeDelete = { ...state.componentTypeDelete, ...change };
    },
    ['SET_COMPONENT_TYPE_SEARCH'](state, change) {
        state.componentTypeSearch = { ...state.componentTypeSearch, ...change };
    }
}
const actions = {
    createComponentType: ({ commit }, payload) => {
        commit('SET_COMPONENT_TYPE_CREATE', { createComponentTypeStatus: null, createdComponentType: null, creatingComponentType: true })
        return Vue.http.post(API_URL + '/componentTypes/create', payload).then(response => {
            commit('SET_COMPONENT_TYPE_CREATE', { createComponentTypeStatus: 'success', createdComponentType: response.body.results.componentType });
        }).catch(response => {
            commit('SET_COMPONENT_TYPE_CREATE', { createComponentTypeStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_TYPE_CREATE', { creatingComponentType: false });
        });
    },
    updateComponentType: ({ commit }, payload) => {
        commit('SET_COMPONENT_TYPE_UPDATE', { updateComponentTypeStatus: null, updatedComponentType: null, updatingComponentType: true })
        return Vue.http.post(API_URL + '/componentTypes/update/' + payload.id, payload)
            .then(response => {
                commit('SET_COMPONENT_TYPE_UPDATE', { updateComponentTypeStatus: 'success', updatedComponentType: response.body.results.componentType });
            })
            .catch(response => {
                commit('SET_COMPONENT_TYPE_UPDATE', { updateComponentTypeStatus: 'failed' });
            })
            .finally(() => {
                commit('SET_COMPONENT_TYPE_UPDATE', { updatingComponentType: false });
            })
    },
    deleteComponentType: ({ commit }, id) => {
        commit('SET_COMPONENT_TYPE_DELETE', { deleteComponentTypeStatus: null, deletedComponentType: null, deletingComponentType: true })
        return Vue.http.delete(API_URL + '/componentTypes/delete/' + id).then(response => {
            commit('SET_COMPONENT_TYPE_DELETE', { deleteComponentTypeStatus: 'success' });
        }).catch(response => {
            commit('SET_COMPONENT_TYPE_DELETE', { deleteComponentTypeStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_TYPE_DELETE', { deletingComponentType: false });
        })
    },
    searchComponentTypes: ({ commit }, payload = { filter: ComponentTypesFilter(), resultMode: 'default' }) => {
        commit('SET_COMPONENT_TYPE_SEARCH', { searchComponentTypeStatus: null, searchComponentType: null, searchingComponentTypes: true })
        let filerJson = JSON.stringify(payload.filter);
        switch (payload.resultMode) {
            case 'count': payload.resultMode = 1; break;
            case 'paginated': payload.resultMode = 2; break;
            case 'paginatedPersist': payload.resultMode = 21; break;
            default: payload.resultMode = 0; break;
        }
        var params = '?query=' + encodeURIComponent(filerJson) + '&result_mode=' + payload.resultMode;
        return Vue.http.get(API_URL + '/componentTypes' + params).then(response => {
            commit('SET_COMPONENT_TYPE_SEARCH', { searchComponentTypeStatus: 'success', componentTypes: response.body.results.componentTypes });
        }).catch(response => {
            commit('SET_COMPONENT_TYPE_SEARCH', { searchComponentTypeStatus: 'failed' });
        }).finally(() => {
            commit('SET_COMPONENT_TYPE_SEARCH', { searchingComponentTypes: false });
        })
    },
}
export default {
    state, mutations, actions
} 



// WEBPACK FOOTER //
// ./resources/js/store/modules/componentTypeStore.js